import { render, staticRenderFns } from "./PressRelease.vue?vue&type=template&id=02a86142&scoped=true"
import script from "./PressRelease.vue?vue&type=script&lang=js"
export * from "./PressRelease.vue?vue&type=script&lang=js"
import style0 from "./PressRelease.vue?vue&type=style&index=0&id=02a86142&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a86142",
  null
  
)

export default component.exports